import { sleep } from "./env";
import { getAppId, getShop } from "./query";

export const initial = async () => {
  await sleep(1);

  const apps = await getAppId();
  if (!apps) return { result: false, reason: "getAppId" };

  //@ts-ignore
  const { shop, locale } = shopify.config;

  const { base } = (() => {
    return {
      base: {
        appId: apps.id,
        functionId: "",
        shop,
        lang: locale.includes("JP") ? "ja" : "en",
        plan: "",
      },
    };
  })();

  const subscriptionStatus = apps.activeSubscriptions.find(
    (s: any) => s.status === "ACTIVE"
  );

  const shopInfor = await getShop();
  if (!shopInfor) return { result: false, reason: "getShopInfor" };

  if (!subscriptionStatus)
    // && !shopInfor.plan.partnerDevelopment)
    return { result: false, reason: "noPayment" };

  // shopInfor.plan.partnerDevelopment = false; // to be deleted
  base.plan = (() => {
    if (shopInfor.plan.partnerDevelopment) return "dev";

    return "ok";
  })();

  return {
    result: true,
    base,
  };
};
